import React from 'react';

const AffiliateProgramSetting = () => {
  return <div>AffiliateProgramSetting</div>;
};

export default AffiliateProgramSetting;
